import React, { FC, isValidElement } from 'react';
import { IProductContext, ITagsConfig, useProductContext } from 'mod/product-list/useProductContext';
import { useProductTags } from 'mod/product-list/useProductTags';
import { toRecord } from 'base/utils/data';
import { TAG_SUPERFLASHSALE } from 'mod/product/constant';
import { ProductTag } from '@base/snippets/ProductTag'
import { getTagConfig } from 'mod/product/utils'
import { IActivityCode } from 'base/interfacesV2/feature'
import SuperFlashSaleOffTag from '@base/snippets/Tags/SuperFlashSaleOffTag'
import cn from 'classnames';
import styles from '@base/product/tags.module.less'

type ITagsMainProps = {
    product: IProductContext['product'];
    tags: ITagsConfig;
};

const Main: FC<ITagsMainProps> = props => {
    const { product, tags } = props;
    const { productTag } = useProductTags({ tag: product.tag, tags });

    if (!productTag) {
        return <></>
    }
    const _tag = productTag.tagName?.toLowerCase()

    const isSuperFlashSale = _tag === TAG_SUPERFLASHSALE
    let tagConfig
    if (isSuperFlashSale) {
        tagConfig = getTagConfig(_tag as IActivityCode, 'listBanner')

        // toDo: 测试
        /*tagConfig = {
            "tagType": 'superflashsale',
            "borderColor": "#05DA54FF",
            "cornerRadius": 0,
            "desc": "",
            "descBackgroundColor": "#FFFFFFFF",
            "descColor": "#05DA54FF",
            "icon": "",
            "image": "",
            "imgHeight": 0,
            "imgWidth": 0,
            "layout": "horizontal",
            "title": "",
            "titleBackgroundColor": "#05DA54FF",
            "titleColor": "#FFFFFFFF"
        }*/

    } else {
        tagConfig = getTagConfig(_tag as IActivityCode, 'picTag')

    }

    return (
        <>
            {isSuperFlashSale ? (
                <SuperFlashSaleOffTag
                    tagConfig={tagConfig}
                    className={'absolute js-scale-full'} // js-scale
                    discount={product.discount}
                />
            ) : (
                <ProductTag
                    tagConfig={tagConfig}
                    discount={product.discount}
                    discountStyle={productTag.discountStyle}
                    className={cn(styles['tags-wrapper'], `g-tag-corner g-tag-${_tag}`)}
                />
            )}
        </>
    )
}

export const Tags: React.FC = () => {
    const {
        product,
        picture
    } = useProductContext();

    const { tags } = toRecord(picture);

    if (tags === false) {
        return null;
    }
    if (isValidElement(tags)) {
        return tags;
    }
    return <Main product={product} tags={toRecord(tags)}/>
};
